import React from 'react';
import { useParams } from 'react-router-dom';
import CreateExpertFormik from './components/createExpertFormik';

export default function CreateArticle() {
  const { id } = useParams();
  return <CreateExpertFormik id={id} />;
}
